import { Button, styled } from '@mui/material';
import { COLOR_SECONDARY, COLOR_ORANGE_PRIMARY, COLOR_WHITE } from '../../constants/color';

export const SecondaryButton = styled(Button)(({ theme }) => ({
    fontSize: '14.5px',
    fontWeight: '600',
    letterSpacing: '1px',
    lineHeight: '130%',
    color: COLOR_WHITE,
    width: '98%',
    textAlign: 'center',
    // background: COLOR_ORANGE_PRIMARY,
    borderRadius: '28px',
    // alignSelf: 'stretch',
    textTransform: 'capitalize',
    padding: '6px 20px',
    gap: '6.08px',
    // height: '44px',
    [theme.breakpoints.down('md')]: {
        height: '36px',
    },
    // '&:hover':{
    //     // backgroundColor: COLOR_ORANGE_PRIMARY,
    //     boxShadow: '0 8px 4px rgba(0, 0, 0, 0.4)',
    // }
}));
